import { render, staticRenderFns } from "./novel_diversity.vue?vue&type=template&id=775d9232&scoped=true"
import script from "./novel_diversity.vue?vue&type=script&lang=js"
export * from "./novel_diversity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d9232",
  null
  
)

export default component.exports